import { Breadcrumb, Paragraph } from '@ets/design-system';
import styles from './ActionBarBreadcrumb.module.scss';
import { useDispatch } from '_common/hooks';
import { clearSelection } from '_common/components/Table/TableSlice';

export type PathElement = { id: string; name?: string };

type ActionBarBreadcrumbProps = {
  path: PathElement[];
  onBreadcrumbElementClick?: (element: PathElement) => void;
  pageLoading?: boolean;
  testId: string;
};

const ActionBarBreadcrumb = ({
  path,
  onBreadcrumbElementClick,
  pageLoading,
  testId,
}: ActionBarBreadcrumbProps) => {
  const dispatch = useDispatch();
  if (!path || pageLoading) {
    return null;
  }

  const onPathElementClick = (element: PathElement) => {
    if (onBreadcrumbElementClick) {
      if (element.id !== path[path.length - 1].id) {
        onBreadcrumbElementClick(element);
      }
    }
    dispatch(clearSelection());
  };

  return (
    <div className={styles.breadCrumb}>
      <Breadcrumb
        breadcrumbs={path.map((item, index) => {
          const isOnly = path.length === 1;
          const isLast = index === path.length - 1;

          const weight: '400' | '600' = isOnly || isLast ? '600' : '400';

          return {
            label: (
              <Paragraph size="m" weight={weight}>
                {item.name}
              </Paragraph>
            ),
            onClick: () => onPathElementClick(item),
          };
        })}
        key={`breadcrumb-${path.length}`}
        testId={testId}
      />
    </div>
  );
};

export default ActionBarBreadcrumb;
